module.exports = __webpack_public_path__ + "img/hc_pro_ten_17.c5d354db.jpg";